import React from 'react';
import { Heading, Loader } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { string, number } = proptypes;
import { VendorCollectionDataModel } from '../VendorCollectionDataModel';

export const VendorCollectionSectionHeading = ({
  sectionTitle,
  productCount
}) => {
  return (
    <Heading>
      <div data-testid="kitchen-product-heading">
        {sectionTitle}
        <span
          className="vendor-collection__product-count"
        >
          {typeof (productCount) === 'number' ? `(${productCount})` : <Loader active small />}
        </span>
      </div>
    </Heading>
  );
};

VendorCollectionSectionHeading.displayName = 'VendorCollectionSectionHeading';

VendorCollectionSectionHeading.dataModel = VendorCollectionDataModel;

VendorCollectionSectionHeading.propTypes = {
  sectionTitle: string.isRequired,
  productCount: number
};

VendorCollectionSectionHeading.defaultProps = {
  productCount: null
};